import { render, staticRenderFns } from "./BirthdayField.vue?vue&type=template&id=539a988c&scoped=true&"
import script from "./BirthdayField.vue?vue&type=script&lang=js&"
export * from "./BirthdayField.vue?vue&type=script&lang=js&"
import style0 from "./BirthdayField.vue?vue&type=style&index=0&id=539a988c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539a988c",
  null
  
)

export default component.exports